import React, { useState } from 'react';
import { useAuthenticator, WithAuthenticatorProps, Button, Authenticator, ThemeProvider } from '@aws-amplify/ui-react';
import { Globe, ArrowRight, Check, Menu, X } from 'lucide-react';
import './HomeScreen.css'; // We'll create this CSS file separately
import { useNavigate } from 'react-router-dom';
import TranslationNavBarComponent from '../generic/TranslationNavBarComponent';


const customTheme = {
    name: 'custom-theme',
    tokens: {
        colors: {
            brand: {
                primary: {
                    10: '{colors.blue.10}',
                    20: '{colors.blue.20}',
                    40: '{colors.blue.40}',
                    60: '{colors.blue.60}',
                    80: '{colors.blue.80}',
                    90: '{colors.blue.90}',
                    100: '{colors.blue.100}',
                },
            },
        },
        components: {
            button: {
                primary: {
                    backgroundColor: '{colors.brand.primary.80}',
                    _hover: {
                        backgroundColor: '{colors.brand.primary.90}',
                    },
                },
            },
            authenticator: {
                modal: {
                    width: '400px',
                    maxWidth: '90%',
                    borderRadius: '8px',
                    backgroundColor: '{colors.white}',
                },
            },
        },
    },
};

const formFields = {
    signIn: {
        username: {
            placeholder: 'Enter your email',
        },
    },
    signUp: {
        email: {
            placeholder: 'Enter your email',
        },
        password: {
            placeholder: 'Create a password',
        },
        confirm_password: {
            placeholder: 'Confirm your password',
        },
    },
};

const HomeScreen = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showSignIn, setShowSignIn] = useState(false);
    const { user, signOut } = useAuthenticator((context) => [context.user]);
    const navigate = useNavigate();

    const handleSignOut = async () => {
        await signOut();
        navigate("/");
    };

    const handleSignInClick = () => {
        setShowSignIn(true);
    };

    return (
        <div className="home-page">
            <TranslationNavBarComponent />
            <main>
                <div className="hero">
                    <img src={`${process.env.PUBLIC_URL}/cit_logo.svg`} alt="Certified International Translations Inc" className="hero-logo" />

                    <h1>Translate Anything, Anywhere</h1>
                    <p>Fast, accurate translations in over 100 languages. Partnered with AI, reviewed by certified translation specialists, and authenticated. Translate documents, PDFs, Images, and text with a certified international translator.</p>
                    {user ? (
                        <button className="cta-button" onClick={()=>navigate("/quotes")}>
                            Get a Quote
                            <ArrowRight className="icon" />
                        </button>
                    ) : (
                        <button className="cta-button" onClick={()=>navigate("/signin")}>
                            Sign Up Now
                            <ArrowRight className="icon" />
                        </button>
                    )}
                </div>

                <div className="features">
                    {[
                        { title: "100+ Languages", description: "Translate between over 100 languages with high accuracy and natural-sounding results." },
                        { title: "AI Partnered", description: "Our advanced AI validates and helps verify our certified translators' work before final draft." },
                        { title: "Fast & Reliable", description: "Get your translations quickly with our high-performance infrastructure and 99.9% uptime." }
                    ].map((feature, index) => (
                        <div key={index} className="feature-card">
                            <div className="feature-icon">
                                <Check />
                            </div>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>

                <div className="try-it-now">
                    <h2>Try it now</h2>
                    <div className="translate-form">
                        <input type="text" placeholder="Enter text to translate" className="translate-input" />
                        <button className="translate-button">Translate</button>
                    </div>
                </div>
            </main>

            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-links">
                        <a href="#">Terms</a>
                        <a href="#">Privacy</a>
                        <a href="#">Contact</a>
                    </div>
                    <div className="footer-copyright">
                        <p>&copy; 2024 Certified International Translations INC. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div >
    );
};

export default HomeScreen;